module.exports = (__webpack_require__(/*! dll-reference main_lib */ "dll-reference main_lib"))("./cloudui/libs/parallax/jquery.parallax-0.2-min.js");